import { datasetSortFieldSchema, type DatasetSortField } from '@contracts/datasets'
import {
  parseBaseListSearch,
  toBaseListParams,
  type BaseListSearch,
  type ListView,
} from '@/shared/lib/list-search'
import type { DatasetListParams } from '../api/datasets.api'

export { DEFAULT_VIEW, PAGE_SIZE_OPTIONS } from '@/shared/lib/list-search'
export type DatasetView = ListView

/**
 * URL state of the dataset list (typed search params of the Datasets route). A default is never
 * written to the address: no `sort` means the backend's default order (newest first).
 */
export type DatasetListSearch = BaseListSearch<DatasetSortField>

/** Tolerant parser: unknown or malformed values are dropped instead of failing the route. */
export function parseDatasetListSearch(search: Record<string, unknown>): DatasetListSearch {
  return parseBaseListSearch(search, datasetSortFieldSchema.options)
}

export function toListParams(search: DatasetListSearch): DatasetListParams {
  return toBaseListParams(search)
}
